export default "__VITE_ASSET__y_npS3wA__"